module.exports = __webpack_public_path__ + "img/loading.9d2b1eab.gif";